import { CircularProgress, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useEnviosGatewayPaginado } from "../../api/ESocialJTServiceApi";
import DataPanel from "../../components/data/DataPanel";
import PainelEnviosGateway from "../../components/envio-gateway/PainelEnviosGateway";
import FiltroEstados from "../../components/estado/FiltroEstados";
import Page from "../../components/layout/page/Page";
import PageHeader from "../../components/page-header/PageHeader";
import {
  useListQueryParam,
  useNumericQueryParam,
  useQueryParam,
  useSetParam
} from "../../shared/useQueryParam";
import Busca from "./Busca";
import Paginacao from "./Paginacao";

function EventosPage() {
  const page = useNumericQueryParam("page");
  const estados = useListQueryParam("estados");
  const expressao = useQueryParam("expressao") || "";
  const tipo = useQueryParam("tipo") || "";
  const dataInicio = useQueryParam("dataInicio") || "";
  const dataFim = useQueryParam("dataFim") || "";
  const navigate = useNavigate();
  const setParam = useSetParam();

  const filtrado =
    estados?.length || tipo || expressao || dataInicio || dataFim;
  const {
    data: envioPage = {},
    isLoading,
    isFetched
  } = useEnviosGatewayPaginado(
    page,
    estados,
    expressao,
    tipo,
    dataInicio,
    dataFim
  );
  const { pagina = {}, contagemEstado = [] } = envioPage;
  const { content: envios } = pagina;

  if ((pagina.totalPages > 0 && page >= pagina.totalPages) || page < 0) {
    navigate(`/?${setParam("page", 0)}`);
  }

  return (
    <Page>
      <PageHeader
        primary="Eventos"
        secondary="Nesta página é possível visualizar os envios processados pelo Gateway eSocial"
        commands={[
          !isFetched ? <CircularProgress key="loading" size={20} /> : undefined
        ]}
      />
      <Busca />
      <FiltroEstados contagemEstado={contagemEstado} />

      <DataPanel
        loading={isLoading}
        isEmpty={pagina.empty}
        emptyMessage={
          filtrado
            ? "Nenhum evento com os filtros selecionados"
            : "Nenhum evento enviado para o eSocial"
        }
        paperEmptyPanel
      >
        <Grid container justifyContent="space-between">
          <Grid item></Grid>
          <Paginacao pagina={pagina} page={page} expressao={expressao} />
        </Grid>

        <PainelEnviosGateway envios={envios} />

        <Grid container justifyContent="space-between">
          <Grid item></Grid>
          <Grid item></Grid>
          <Paginacao pagina={pagina} page={page} />
        </Grid>
      </DataPanel>
    </Page>
  );
}

export default EventosPage;
